import { AppData } from '@lightningjs/sdk';
import ParentalPin from 'components/widgets/parental-pin/ParentalPin';
import { translate } from 'support/translate';
import { getFocusDepth } from 'support/generalUtils';

export default class SetParentalPin extends ParentalPin {
  private pinToMatch: string | null = null;

  protected override update() {
    if (this.pinToMatch) {
      this.title = translate('ParentalPin.setPin.titleReEnter');
      this.description = translate('ParentalPin.setPin.descriptionReEnter');
    } else {
      this.title = translate('ParentalPin.setPin.title');
      this.description = translate('ParentalPin.setPin.description');
    }
    super.update();
  }

  override closeWidget(wasValidated = false) {
    this.pinToMatch = null;
    if (wasValidated) {
      AppData?.modalService.closeAll();
    } else {
      AppData?.modalService.close();
    }
    this.resetStates();
  }

  override $cancel() {
    this.closeWidget();
  }

  override $validate() {
    if (this.pin.length !== 4) {
      this.handleInvalidPin();
      return;
    }

    if (!this.pinToMatch) {
      this.pinToMatch = this.pin;
      this.clearInput();
      this.update();

      this.fireAncestors(
        '$announcerRefresh',
        getFocusDepth(
          // @ts-ignore
          this.application,
          this as SetParentalPin,
        ),
      );
      return;
    }

    if (this.pinToMatch === this.pin) {
      AppData!.parentalPinService.setNewPin(this.pin, true);
      this.onValidate?.();
      this.closeWidget(true);
    } else {
      this.handleInvalidPin();
    }
  }
}
